import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Avatar, AvatarImage, AvatarFallback } from '../components/ui/avatar';
import { ArrowLeft } from 'lucide-react';
import AboutSection from '../components/AboutSection';
import ExperienceSection from '../components/ExperienceSection';
import SkillsSection from '../components/SkillsSection';
import EducationSection from '../components/EducationSection';
import ResearchSection from '../components/ResearchSection';
import ContactSection from '../components/ContactSection';

const DoctorProfilePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      {/* Hero Section */}
      <div className="relative pt-32 pb-20 px-4" style={{ background: 'linear-gradient(135deg, #053827 0%, #0a5a40 100%)' }}>
        <div className="container mx-auto max-w-6xl">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="mb-6 text-white border-white hover:bg-white/20"
          >
            <ArrowLeft className="mr-2" size={16} />
            {t('backToHome')}
          </Button>

          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-8">
            <Avatar className="w-24 h-24 sm:w-32 sm:h-32 border-4 border-white shadow-2xl flex-shrink-0" data-testid="doctor-profile-photo">
              <AvatarImage src="/gallery-images/doctor.jpg" alt="Dr. Nikhil Tonge" className="object-cover" />
              <AvatarFallback className="text-white text-3xl sm:text-4xl font-bold" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                NT
              </AvatarFallback>
            </Avatar>
            <div className="text-center sm:text-left">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2 break-words">
                {t('team.name')}
              </h1>
              <p className="text-xl sm:text-2xl font-semibold text-emerald-100 mb-2">
                {t('team.degree')}
              </p>
              <p className="text-base sm:text-lg text-emerald-200">
                {t('team.specialization')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto max-w-6xl px-4 py-16">
        <div className="space-y-8">
          <AboutSection />
          <ExperienceSection />
          <SkillsSection />
          <EducationSection />
          <ResearchSection />
          <ContactSection isDoctorProfile={true} />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DoctorProfilePage;
